(() => {
  const DISCOUNT_QUANTITY = 6;
  const SHOW_FROM_QUANTITY = 3;

  let refreshTimer;

function getMessage(quantity) {

  if (quantity <= 2) {
    return "Save 10% when buying any* 6 wines";
  }

  if (quantity >= DISCOUNT_QUANTITY) {
    return "Your 10% wine discount has been applied.";
  }

  const remaining = DISCOUNT_QUANTITY - quantity;

  return remaining === 1
    ? "Add 1 more wine to save 10%."
    : `Add ${remaining} more wines to save 10%.`;
}

  function updateDiscountMessages(quantity) {
    const message = getMessage(quantity);

    document
      .querySelectorAll("[data-wine-discount-message]")
      .forEach((element) => {
        element.textContent = message;
        element.hidden = !message;
      });
  }

  function updateHeaderCartCount(quantity) {
    const cartLinks = document.querySelectorAll(
      'a[class*="header-cart-sections--"]'
    );

    cartLinks.forEach((cartLink) => {
      let bubble = cartLink.querySelector(".cart-count-bubble");
      let countText = bubble?.querySelector(
        'span[aria-hidden="true"]'
      );

      if (quantity > 0) {
        if (!bubble) {
          bubble = document.createElement("div");
          bubble.className = "cart-count-bubble";

          countText = document.createElement("span");
          countText.setAttribute("aria-hidden", "true");

          bubble.appendChild(countText);
          cartLink.appendChild(bubble);
        }

        if (!countText) {
          countText = document.createElement("span");
          countText.setAttribute("aria-hidden", "true");
          bubble.appendChild(countText);
        }

        countText.textContent = quantity;
        bubble.hidden = false;
      } else if (bubble) {
        bubble.hidden = true;
      }
    });
  }

  function resetProductQuantity() {
    document
      .querySelectorAll(
        [
          "form[action*='/cart/add'] input[name='quantity']",
          "product-form input[name='quantity']",
          "[data-product-form] input[name='quantity']"
        ].join(",")
      )
      .forEach((input) => {
        input.value = "1";

        input.dispatchEvent(
          new Event("input", {
            bubbles: true
          })
        );

        input.dispatchEvent(
          new Event("change", {
            bubbles: true
          })
        );
      });
  }

  async function getCart() {
    const root = window.Shopify?.routes?.root || "/";

    const response = await fetch(`${root}cart.js`, {
      method: "GET",
      headers: {
        Accept: "application/json"
      },
      cache: "no-store"
    });

    if (!response.ok) {
      throw new Error(`Cart request failed: ${response.status}`);
    }

    return response.json();
  }

  async function refreshCartDisplays() {
    try {
      const cart = await getCart();

      updateDiscountMessages(cart.item_count);
      updateHeaderCartCount(cart.item_count);
    } catch (error) {
      console.error("Cart display update error:", error);
    }
  }

  function scheduleRefresh(delay = 400) {
    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(() => {
      refreshCartDisplays();
    }, delay);
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    const requestUrl =
      typeof args[0] === "string"
        ? args[0]
        : args[0]?.url || "";

    const isAddRequest = requestUrl.includes("/cart/add");

    const isCartUpdate =
      isAddRequest ||
      requestUrl.includes("/cart/change") ||
      requestUrl.includes("/cart/update") ||
      requestUrl.includes("/cart/clear");

    if (response.ok && isCartUpdate) {
      if (isAddRequest) {
        window.setTimeout(resetProductQuantity, 200);
      }

      scheduleRefresh(500);
    }

    return response;
  };

  document.addEventListener("cart:update", () => {
    scheduleRefresh();
  });

  document.addEventListener("cart:refresh", () => {
    scheduleRefresh();
  });

  document.addEventListener(
    "shopify:cart:lines-update",
    () => {
      scheduleRefresh();
    }
  );

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      refreshCartDisplays
    );
  } else {
    refreshCartDisplays();
  }

  window.addEventListener(
    "pageshow",
    refreshCartDisplays
  );
})();